/* ta-label-inspector: interactive label diagram. Markup, data and wording come from
   snippets/ta-label-inspector.liquid; this script only builds and lays out the diagram. */
(function () {
  if (window.customElements && customElements.get('ta-label-inspector')) return;
  var NS = 'http://www.w3.org/2000/svg';

  class TaLabelInspector extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      var self = this;
      try { this.data = JSON.parse(this.querySelector('[data-tali-data]').textContent); } catch (e) { return; }
      this.dialog = this.querySelector('.tali-dialog');
      document.body.appendChild(this.dialog);        /* keep the dialog out of the gallery's layout */
      this.querySelector('[data-tali-open]').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.open(); });
      this.dialog.querySelector('[data-tali-close]').addEventListener('click', function () { self.dialog.close(); });
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.dialog.close(); });
      this.dialog.addEventListener('close', function () { self.sel(null); });
      this.mq = window.matchMedia('(max-width: 760px)');
    }
    open() {
      if (!this.built) this.build();
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
      var self = this;
      if (this.img.complete) requestAnimationFrame(function () { self.layout(); });
    }
    build() {
      this.built = true;
      var self = this, d = this.dialog, data = this.data;
      this.dia = d.querySelector('[data-tali-dia]'); this.tube = d.querySelector('[data-tali-tube]');
      this.img = d.querySelector('[data-tali-img]'); this.svg = d.querySelector('[data-tali-leads]'); this.list = d.querySelector('[data-tali-list]');
      this.img.addEventListener('load', function () { self.layout(); });
      this.img.src = data.img;
      this.items = data.map.map(function (m, i) {
        var info = data.items[m.k] || { t: m.k, v: '', d: '' };
        /* Shopify's translation filter returns HTML-escaped text (an apostrophe arrives as &#39;);
           decode it once here, then escape it properly when it is put on the page */
        var h = { k: m.k, x: m.x, y: m.y, w: m.w, h: m.h, side: m.side, n: i + 1, t: dec(info.t), v: dec(info.v || ''), d: dec(info.d || '') };
        var strong = h.v ? '<strong>' + esc(h.v) + '</strong>' : '<strong>' + esc(h.t) + '</strong>';
        var small = h.v ? '<small>' + esc(h.t) + '</small>' : '';
        h.box = el('div', 'tali-box'); self.dia.appendChild(h.box);
        h.co = el('button', 'tali-co ' + h.side); h.co.type = 'button'; h.co.innerHTML = small + strong + '<p>' + esc(h.d) + '</p>'; self.dia.appendChild(h.co);
        h.pin = el('button', 'tali-pin'); h.pin.type = 'button'; h.pin.textContent = h.n; h.pin.setAttribute('aria-label', h.t + (h.v ? ': ' + h.v : '')); self.dia.appendChild(h.pin);
        var li = el('li'); li.innerHTML = '<button type="button"><span class="n">' + h.n + '</span><span>' + small + strong + '<p>' + esc(h.d) + '</p></span></button>';
        self.list.appendChild(li); h.li = li;
        h.g = document.createElementNS(NS, 'g'); self.svg.appendChild(h.g);
        var hover = function () { if (!self.mq.matches) self.sel(h); };
        var tap = function () { self.sel(h === self.cur && self.mq.matches ? null : h); };
        h.co.addEventListener('mouseenter', hover); h.co.addEventListener('focus', function () { self.sel(h); }); h.co.addEventListener('click', function () { self.sel(h); });
        h.box.addEventListener('mouseenter', hover); h.box.addEventListener('click', tap);
        h.pin.addEventListener('click', tap); li.firstChild.addEventListener('click', tap);
        return h;
      });
      this.dia.addEventListener('mouseleave', function () { if (!self.mq.matches) self.sel(null); });
      /* phones: explanations open in a card that slides up over the bottom of the screen, with a
         close-up of that part of the label and arrows to step through the elements */
      var closeLbl = d.querySelector('[data-tali-close]').getAttribute('aria-label') || '';
      this.sheet = el('div', 'tali-sheet'); this.sheet.setAttribute('role', 'dialog');
      this.sheet.innerHTML = '<button type="button" class="tali-sheet__x" aria-label="' + esc(closeLbl) + '">×</button>' +
        '<div class="tali-sheet__zoom" aria-hidden="true"></div>' +
        '<div class="tali-sheet__body"><span class="tali-sheet__n"></span><div><small></small><strong></strong><p></p></div></div>' +
        '<div class="tali-sheet__nav"><button type="button" class="tali-sheet__prev">‹</button><span class="tali-sheet__count"></span><button type="button" class="tali-sheet__next">›</button></div>';
      d.querySelector('.tali-card').appendChild(this.sheet);
      this.sheet.querySelector('.tali-sheet__x').addEventListener('click', function () { self.sel(null); });
      this.sheet.querySelector('.tali-sheet__prev').addEventListener('click', function () { self.step(-1); });
      this.sheet.querySelector('.tali-sheet__next').addEventListener('click', function () { self.step(1); });
      var sx = null;   /* swipe the card sideways to step */
      this.sheet.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      this.sheet.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 50) self.step(dx < 0 ? 1 : -1); });
      window.addEventListener('resize', function () { if (self.dialog.open) self.layout(); });
    }
    geo() {
      var dr = this.dia.getBoundingClientRect(), ir = this.img.getBoundingClientRect(), tr = this.tube.getBoundingClientRect();
      return { W: dr.width, ix: ir.left - dr.left, iy: ir.top - dr.top, iw: ir.width, ih: ir.height, tl: tr.left - dr.left, tw: tr.width };
    }
    layout() {
      if (!this.items || !this.img.naturalWidth) return;
      var mob = this.mq.matches, self = this;
      /* phones: show the whole product, as large as fits between the pins */
      if (mob) {
        var asp = this.img.naturalWidth / this.img.naturalHeight, room = this.dia.clientWidth - 84, pad = 8;
        var Hd = Math.min(this.dia.clientHeight - pad * 2, room / asp);
        this.img.style.height = Hd + 'px';
        this.img.style.marginTop = ((this.dia.clientHeight - Hd) / 2) + 'px';
      } else { this.img.style.height = ''; this.img.style.marginTop = ''; }
      var G = this.geo();
      this.items.forEach(function (h) {
        var x = G.ix + h.x / 100 * G.iw, y = G.iy + h.y / 100 * G.ih, w = h.w / 100 * G.iw, hh = h.h / 100 * G.ih;
        h.box.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + w + 'px;height:' + hh + 'px';
        h.ax = h.side === 'L' ? x : x + w; h.ay = y + hh / 2;
      });
      ['L', 'R'].forEach(function (side) {
        var items = self.items.filter(function (h) { return h.side === side; }).sort(function (a, b) { return a.ay - b.ay; });
        var CW = mob ? 0 : 250;
        var colX = mob ? (side === 'L' ? G.tl - 26 : G.tl + G.tw + 26) : (side === 'L' ? Math.max(0, G.tl - 40 - CW) : Math.min(G.W - CW, G.tl + G.tw + 40));
        var gap = mob ? 6 : 14, prev = -1e9;
        items.forEach(function (h) {
          var ch = mob ? 24 : (h.co.offsetHeight || 50), top = Math.max(h.ay - ch / 2, prev + gap);
          h.cy = top + ch / 2; prev = top + ch;
          if (mob) { h.pin.style.left = colX + 'px'; h.pin.style.top = h.cy + 'px'; h.cx = side === 'L' ? colX + 12 : colX - 12; }
          else { h.co.style.left = colX + 'px'; h.co.style.top = top + 'px'; h.cx = side === 'L' ? colX + CW : colX; }
        });
        items.forEach(function (h) {
          var elbow = side === 'L' ? G.tl - (mob ? 6 : 18) : G.tl + G.tw + (mob ? 6 : 18), k = side === 'L' ? -1 : 1;
          h.g.innerHTML = '<path d="M' + h.ax + ' ' + h.ay + ' L' + elbow + ' ' + h.ay + ' L' + (elbow + k * (mob ? 4 : 10)) + ' ' + h.cy + ' L' + h.cx + ' ' + h.cy + '"/><circle cx="' + h.ax + '" cy="' + h.ay + '" r="' + (mob ? 2.2 : 3) + '"/>';
        });
      });
    }
    step(dir) {
      if (!this.cur) return;
      var list = this.items.slice().sort(function (a, b) { return a.n - b.n; }), i = list.indexOf(this.cur);
      this.sel(list[(i + dir + list.length) % list.length]);
    }
    fillSheet(h) {
      var s = this.sheet; if (!s) return;
      if (!h || !this.mq.matches) { s.classList.remove('open'); this.shift(0); return; }
      s.querySelector('.tali-sheet__n').textContent = h.n;
      s.querySelector('small').textContent = h.v ? h.t : '';
      s.querySelector('strong').textContent = h.v || h.t;
      s.querySelector('p').textContent = h.d;
      s.querySelector('.tali-sheet__count').textContent = h.n + ' / ' + this.items.length;
      var list = this.items.slice().sort(function (a, b) { return a.n - b.n; }), i = list.indexOf(h);
      s.querySelector('.tali-sheet__prev').setAttribute('aria-label', list[(i - 1 + list.length) % list.length].t);
      s.querySelector('.tali-sheet__next').setAttribute('aria-label', list[(i + 1) % list.length].t);
      /* close-up: the element, magnified from the same photo */
      var z = s.querySelector('.tali-sheet__zoom'), W = z.clientWidth || 300, H = z.clientHeight || 96,
          iw = this.img.naturalWidth, ih = this.img.naturalHeight;
      var Z = Math.min(W * .86 / (h.w / 100 * iw), H * .8 / (h.h / 100 * ih), 3.2);
      z.style.backgroundImage = 'url("' + this.img.currentSrc + '")';
      z.style.backgroundSize = (iw * Z) + 'px ' + (ih * Z) + 'px';
      z.style.backgroundPosition = (W / 2 - (h.x + h.w / 2) / 100 * iw * Z) + 'px ' + (H / 2 - (h.y + h.h / 2) / 100 * ih * Z) + 'px';
      s.classList.add('open');
      /* keep the highlighted part of the label visible above the card */
      var self = this;
      requestAnimationFrame(function () {
        var sheetTop = window.innerHeight - 10 - s.offsetHeight, r = h.box.getBoundingClientRect();
        var base = r.bottom - (self._shift || 0), need = base + 18 - sheetTop;
        self.shift(need > 0 ? -need : 0);
      });
    }
    shift(px) {
      this._shift = px;
      if (this.dia) { this.dia.style.transition = 'transform .28s cubic-bezier(.2,.8,.2,1)'; this.dia.style.transform = px ? 'translateY(' + px + 'px)' : ''; }
    }
    sel(h) {
      this.cur = h;
      if (!this.items) return;
      this.fillSheet(h);
      this.items.forEach(function (o) {
        var on = o === h;
        o.box.classList.toggle('on', on); o.co.classList.toggle('on', on); o.g.classList.toggle('on', on);
        o.pin.classList.toggle('on', on); o.li.classList.toggle('on', on);
      });
      this.layout();   /* the open callout grows, so the ones below it move down */
    }
  }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function dec(s) { var t = document.createElement('textarea'); t.innerHTML = String(s); return t.value; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  customElements.define('ta-label-inspector', TaLabelInspector);
})();